import { Input } from '@/components/ui/input'
import { normalizeDecimalInput } from '@/lib/decimal'

interface DecimalInputProps {
  id?: string
  name?: string
  'data-testid'?: string
  value: string
  onValueChange: (next: string) => void
  className?: string
  placeholder?: string
  disabled?: boolean
  allowNegative?: boolean
  onBlur?: () => void
}

export function DecimalInput({
  id,
  name,
  'data-testid': dataTestid,
  value,
  onValueChange,
  className,
  placeholder,
  disabled,
  allowNegative,
  onBlur,
}: DecimalInputProps) {
  return (
    <Input
      id={id}
      name={name}
      data-testid={dataTestid}
      className={className}
      type="text"
      inputMode="decimal"
      autoComplete="off"
      value={value}
      placeholder={placeholder}
      disabled={disabled}
      onChange={(e) => {
        onValueChange(normalizeDecimalInput(e.target.value, { allowNegative }))
      }}
      onBlur={onBlur}
    />
  )
}
